import { useTranslation } from 'react-i18next';
import { sqWorkbenchStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { ImpactReportDetail, ImpactReportDetailHeader } from '@/impactReports/ImpactReportDetail.page';
import { canEditImpactReport } from '@/impactReports/impactReport.utilities';
import { useImpactReportCategories } from '@/impactReports/impactReports.store';
import { Modal } from '@seeqdev/qomponents';
import type { ImpactReportUseCase } from '@/impactReports/impactReport.types';

interface ImpactReportDetailModalProps {
  closeFn: () => void;
  details: ImpactReportUseCase;
  editCallbackFn?: () => void;
}

export const ImpactReportDetailModal = ({ closeFn, details, editCallbackFn }: ImpactReportDetailModalProps) => {
  const currentUser = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.currentUser);

  const { t } = useTranslation();
  const categories = useImpactReportCategories();

  const onEdit = editCallbackFn && canEditImpactReport(details, currentUser.id) ? editCallbackFn : undefined;

  return (
    <Modal
      title={t('IMPACT_REPORT.DETAIL')}
      size="4xl"
      submitButtonLabel={t('EDIT')}
      cancelButtonLabel={t('CLOSE')}
      hideFooterButtons={true}
      open={true}
      onSubmit={onEdit}
      onClose={closeFn}
      customHeader={<ImpactReportDetailHeader {...details} />}>
      <ImpactReportDetail {...details} categories={categories} onClose={closeFn} onEdit={onEdit} />
    </Modal>
  );
};
